import {
  TreeNode,
  TreeNodeType,
} from "~/components/build/Show/pages/steps/list/components/TreeNode";

export function createSpacerNode(id: string): TreeNode {
  return {
    id,
    type: TreeNodeType.Spacer,
    render: () => null,
  };
}
